import { Box } from "@mui/material";
import Header from "../components/Header";
import Gallery from "../components/Gallery";
import Locations from "../components/Locations";
import SalonVideos from "../components/SalonVideos";

const LandingPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "background.default",
      }}
    >
      {/* Box is essentially a wrapper component (like a div) with superpowers. It allows you to:
      Apply CSS styles using the sx prop (MUI's shorthand styling system)
      Set up layout properties like display, flexDirection, padding, margin, etc., 
      without using external CSS or styled-components. 
      This outer Box acts like a vertical flex container.

      display: "flex" and flexDirection: "column" mean child elements (Header, the inner Box, etc.) will be stacked vertically.

      minHeight: "100vh" ensures it takes at least the full height of the viewport.

      backgroundColor: "background.default" uses the background color from your MUI theme — so it stays consistent with the app's look and feel.*/}

      <Header />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <SalonVideos />
        <Locations />
        <Gallery />
      </Box>
      {/* This inner Box is the main content area, marked with component="main" (for semantic HTML).
          flexGrow: 1 means it will take up the remaining vertical space between Header and the page bottom.
          This is important in responsive layouts. */}
    </Box>
  );
};

export default LandingPage;
